'use strict'

export default (mockAxios) => {
  // プロフィール取得
  mockAxios.onGet(`/profiles`).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'loginid': 'abcdefghij',
      'word_': '***************',
      'last_name': '山田',
      'first_name': '太郎',
      'last_kana': 'やまだ',
      'first_kana': 'たろう',
      'corporate_name': 'サンプル会社',
      'corporate_kana': 'さんぷるかいしゃ',
      'dept': 'サンプル部署1',
      'post': 'サンプル役職',
      'zipcode': '123-4567',
      'address1': '東京都八王子市上川町2-4-9',
      'address2': 'マンション上川町第1 12F',
      'corporate_tel': '0330-88-1590',
      'dept_tel': '0330-88-1590',
      'naisen': 'string',
      'hand_tel': 'string',
      'fax': 'string',
      'mail': 'yamada@example.com',
      'url': 'http://www.rrr-computer.jp',
      'defgroup': 1,
      'image_id': '01k20094169p8y3t',
      'images': [],
      'group_users': [],
      'nochgfields': []
    }
  })

  // プロフィール更新
  mockAxios.onPost(`/profiles`).reply(201, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/profileSettingRepositoryMock.js